const stats = [
  { value: "28+", label: "精选影视", icon: "ri-film-line" },
  { value: "13", label: "影视类型", icon: "ri-price-tag-3-line" },
  { value: "7", label: "覆盖地区", icon: "ri-global-line" },
  { value: "每日", label: "资源更新", icon: "ri-refresh-line" },
];

const highlights = [
  {
    icon: "ri-search-eye-line",
    title: "多维筛选",
    desc: "按类型、地区、年份、集数自由组合，几秒钟锁定想看的内容。",
  },
  {
    icon: "ri-layout-grid-line",
    title: "清晰聚合",
    desc: "电影与电视剧分区展示，海报、评分、简介一目了然。",
  },
  {
    icon: "ri-heart-3-line",
    title: "个人收藏",
    desc: "一键收藏喜欢的影片，本地保存，下次打开依然在。",
  },
];

export default function IntroSection() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-100 border-t border-background-300">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
        <div>
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-400 mb-3">
            <i className="ri-vip-crown-2-line"></i>
            关于黄色影院
          </span>
          <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading leading-snug mb-4">
            黄色影院 · 高清电影电视剧资源聚合平台
          </h1>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
            黄色影院集中展示丰富的电影与电视剧资源，覆盖动作、科幻、悬疑、古装、都市等多种类型。
            我们以清晰的内容分层、高效的筛选工具和舒适的视觉体验，帮助每一位影视爱好者便捷浏览、
            快速定位、深入了解心仪的影片，让找片这件事变得简单又愉快。
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center rounded-lg bg-background-50 border border-background-300 py-4">
                <span className="w-8 h-8 mx-auto mb-2 flex items-center justify-center">
                  <i className={`${stat.icon} text-lg text-primary-400`}></i>
                </span>
                <div className="text-xl font-bold text-foreground-950 font-label">{stat.value}</div>
                <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="space-y-4">
          {highlights.map((item) => (
            <div
              key={item.title}
              className="flex items-start gap-4 rounded-lg bg-background-50 border border-background-300 p-5"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-secondary-100 border border-secondary-200 shrink-0">
                <i className={`${item.icon} text-xl text-secondary-900`}></i>
              </span>
              <div>
                <h3 className="text-base font-semibold text-foreground-950 mb-1">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}